import TopSection from "./top-section";
import React, {ReactNode} from "react";
import {DEFAULT_BORDER, useRpx} from "../shared";
import Circles from "./circles";

interface LeftGridProps {
    content: ReactNode;
    description: ReactNode;
    extended: boolean;
}

export default function LeftGrid({content, description, extended}: LeftGridProps) {
    const rpx = useRpx();

    return (
        <div
            style={{
                height: '100%',
                position: 'relative'
            }}
        >
            <TopSection>
                <>
                    <div
                        style={{
                            borderRight: DEFAULT_BORDER,
                            height: '100%',
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Logo/>
                    </div>
                    <div style={{height: '100%', overflow: 'hidden', display: 'flex', alignItems: 'flex-end'}}>
                        <div style={{transform: 'rotate(180deg)'}}>
                            <Circles/>
                        </div>
                    </div>
                </>
            </TopSection>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%',
                    position: 'relative'
                }}
            >
                <div
                    style={{
                        height: rpx(extended ? 590 : 480),
                        width: '100%',
                        borderBottom: DEFAULT_BORDER,
                        flexShrink: 0,
                    }}
                >
                    {content}
                </div>
                <div
                    style={{
                        height: '50%',
                        display: 'flex',
                    }}
                >
                    <div
                        style={{
                            width: '50%',
                            borderRight: DEFAULT_BORDER,
                        }}
                    >
                        <Circles/>
                    </div>
                    <div
                        style={{
                            width: '50%',
                            position: 'relative',
                        }}
                    >
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
}

function Logo() {
    const rpx = useRpx();

    return (
        <div
            style={{
                height: rpx(115),
                width: '100%',
                marginLeft: rpx(50),
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    width: 'auto',
                    height: '100%',
                    // objectFit: 'contain',
                }}
                // width="201"
                // height="117"
                fill="none"
                viewBox="0 0 201 117"
            >
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M24.833 31.792l-2.078-6.881c-.31-1.025-1.226-3.589-1.606-4.6v-.003L13.884.768H.768v53.218H13.86V40.49c0-2.134-.09-8.945-.18-10.366l-.387-6.193 1.886 5.912c.289.904 2.508 7.056 4.666 13.013a8929.956 8929.956 0 003.874 10.67l.175.48h13.194V.787h-13.2v13.489c0 2.122.263 9.021.37 10.351l.576 7.165zM23.119.02h14.737v54.754H23.355s-5.809-15.954-8.063-22.278c-.443-1.245-.749-2.116-.846-2.42.028.444.056 1.395.081 2.56.057 2.638.1 6.377.1 7.854v14.266H0V0h14.419l7.45 20.04c.166.444.436 1.187.714 1.97.359 1.01.73 2.087.908 2.679-.036-.451-.09-1.521-.145-2.826-.11-2.61-.227-6.161-.227-7.587V.019zM55.869.787H42.17v53.199h13.698V.787zm.768-.768v54.735H41.402V.02h15.235zM83.253 54.934h16.649L86.667 26.728 98.479.372H82.193l-7.45 17.26.074-17.26H59.173v54.562h15.644l-.084-19.222 8.52 19.222zm-9.208-.769l-.096-22.12 9.804 22.12h14.94L85.82 26.735 97.292 1.142H82.698l-8.74 20.247.087-20.247H59.941v53.024h14.104z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M115.022 41.604v-8.34h11.25V21.476h-11.25V13.42h12.544V1.14H100.67v53.024h26.896v-12.56h-12.544zm13.313-.768v14.098H99.901V.372h28.434v13.815H115.79v6.52h11.251v13.325H115.79v6.804h12.545zM15.561 81.856h-.326V73.97h.806c2.946 0 4.323 1.25 4.323 3.938a3.592 3.592 0 01-.28 1.57c-.209.493-.526.928-.925 1.27l.5.583c.491-.42.878-.953 1.133-1.553.252-.595.368-1.24.34-1.888-.002-1.46-.38-2.684-1.307-3.528-.915-.832-2.222-1.16-3.784-1.16h-1.575v9.422h1.07a6.274 6.274 0 004.104-1.208l-.454-.62a5.506 5.506 0 01-3.625 1.06zm4.525 20.424l-.016.014a6.193 6.193 0 01-4.26 1.393h-1.344V93.204h1.215a6.509 6.509 0 014.382 1.353l.022.017.021.019a4.712 4.712 0 011.224 1.746c.265.657.384 1.366.348 2.075a4.972 4.972 0 01-.354 2.089 4.807 4.807 0 01-1.222 1.763l-.016.014zm.822-3.867a4.106 4.106 0 00-.29-1.786 3.944 3.944 0 00-1.024-1.462 5.74 5.74 0 00-3.888-1.192h-.471v8.946h.598a5.423 5.423 0 003.752-1.222 4.035 4.035 0 001.027-1.481c.23-.57.33-1.187.296-1.803zm5.478-10.552l2.27-.795c2.088-.731 3.595-1.896 4.593-3.523 1.006-1.64 1.536-3.818 1.536-6.639v-.006a16.785 16.785 0 00-1.065-6.027 12.409 12.409 0 00-3.229-4.773 15.112 15.112 0 00-5.549-3.113h-.002a25.267 25.267 0 00-7.916-1.13H.768v53.198h19.477c2.137.022 4.262-.35 6.278-1.097l.001-.001a14.084 14.084 0 004.895-3.076 14.03 14.03 0 003.175-4.815 16.566 16.566 0 001.134-6.205v-.007c0-3.725-.881-6.486-2.525-8.331l.036-.032a9.393 9.393 0 00-4.542-2.96l-2.311-.668zm7.391 3.149l.027.03c1.795 2.035 2.692 4.997 2.692 8.811a17.338 17.338 0 01-1.187 6.495 14.798 14.798 0 01-3.353 5.083 14.858 14.858 0 01-5.166 3.247 18.313 18.313 0 01-6.553 1.146H0V61.086h17.011c2.76-.048 5.51.345 8.157 1.164a15.883 15.883 0 015.836 3.276A13.179 13.179 0 0134.44 70.6a17.556 17.556 0 011.115 6.305c0 5.325-1.828 8.71-5.552 10.444-.347.161-.711.309-1.091.442.377.11.746.24 1.107.393 1.449.612 2.75 1.566 3.795 2.794l.028.032h-.064zM103.831 74.338l-.039-.156a82.607 82.607 0 00-1.36-4.46l-2.719-8.387h-15.95l13.195 31.619v23.127h15.307V92.944l12.353-31.609h-15.914l-2.719 8.378a66.114 66.114 0 00-1.323 4.478l-.038.146c-.132.52-.264 1.037-.388 1.54l-.114-.429c-.097-.364-.195-.735-.291-1.11zm1.575.044c-.145.568-.289 1.133-.424 1.679l-.722 2.916-.767-2.905-.112-.422c-.11-.413-.224-.841-.333-1.273a81.494 81.494 0 00-1.344-4.409l-.003-.008-2.546-7.856H84.916L97.726 92.8v22.512h13.771V92.799l11.996-30.695h-14.231l-2.548 7.852a66.11 66.11 0 00-1.308 4.426zM51.722 69.47l-2.718-8.388h-15.96L46.249 92.7v23.127h15.298V92.691l12.352-31.609H57.985l-2.719 8.378a61.629 61.629 0 00-1.354 4.633c-.131.516-.262 1.03-.386 1.53l-.453-1.695a91.63 91.63 0 00-1.35-4.459zm6.822-7.62l-2.549 7.853a60.848 60.848 0 00-1.297 4.421l-.001.004c-.146.568-.29 1.133-.425 1.68l-.717 2.896-1.223-4.572v-.003a90.862 90.862 0 00-1.339-4.418l-.002-.005-2.546-7.856H34.198l12.819 30.696v22.513h13.761V92.546L72.774 61.85h-14.23zM136.319 78.126l.001-.002c.848-2.258 2.089-3.764 3.982-3.764 1.891 0 3.141 1.502 3.982 3.763.957 2.5 1.382 6.087 1.382 10.59 0 4.508-.445 8.074-1.382 10.552-.844 2.241-2.097 3.715-3.982 3.715-1.885 0-3.129-1.476-3.98-3.712-.958-2.482-1.383-6.062-1.383-10.555 0-4.502.454-8.093 1.38-10.587zm7.246 20.867c-.816 2.168-1.885 3.219-3.263 3.219-1.377 0-2.438-1.051-3.262-3.219-.907-2.347-1.333-5.812-1.333-10.28 0-4.469.454-7.952 1.333-10.319.824-2.196 1.885-3.266 3.262-3.266 1.378 0 2.447 1.07 3.263 3.266.906 2.367 1.332 5.84 1.332 10.319 0 4.477-.444 7.933-1.332 10.28zm11.555-30.728a19.743 19.743 0 00-6.471-5.86 17.834 17.834 0 00-8.365-2.092c-2.907 0-5.773.717-8.365 2.092a19.833 19.833 0 00-6.435 5.86 28.18 28.18 0 00-4.123 8.955 46.218 46.218 0 000 22.9 28.233 28.233 0 004.123 8.965 19.438 19.438 0 006.444 5.822 18.103 18.103 0 008.361 2.054c2.901 0 5.763-.703 8.36-2.054a19.432 19.432 0 006.471-5.822 28.001 28.001 0 004.124-8.965 46.218 46.218 0 000-22.9 27.994 27.994 0 00-4.124-8.955zm3.38 9.148a45.457 45.457 0 010 22.514 27.232 27.232 0 01-4.009 8.716 18.645 18.645 0 01-6.205 5.586 17.33 17.33 0 01-7.997 1.964c-2.774 0-5.511-.672-7.997-1.963a18.662 18.662 0 01-6.178-5.586 27.457 27.457 0 01-4.009-8.717 45.43 45.43 0 010-22.514 27.403 27.403 0 014.009-8.708 19.058 19.058 0 016.175-5.626 17.06 17.06 0 017.995-1.998c2.778 0 5.517.684 7.997 1.999a18.973 18.973 0 016.21 5.626 27.232 27.232 0 014.009 8.707zM185.215 101.447l-.035.059c-.3.506-.736.917-1.259 1.179a2.942 2.942 0 01-1.599.3 3.1 3.1 0 01-1.626-.306 3.224 3.224 0 01-1.303-1.173l-.037-.059-.026-.064a11.277 11.277 0 01-.79-4.981V62.103h-13.743V97.72a22.854 22.854 0 001.305 8.047 16.351 16.351 0 003.586 5.761 14.892 14.892 0 005.51 3.507 20.639 20.639 0 007.138 1.195h.017a20.331 20.331 0 007.1-1.195 14.53 14.53 0 005.517-3.557 15.409 15.409 0 003.514-5.711 23.497 23.497 0 001.272-8.048V62.103h-13.788v34.3a12.004 12.004 0 01-.729 4.98l-.024.064zm-.016-40.112h15.325v36.371a24.245 24.245 0 01-1.314 8.312 16.185 16.185 0 01-3.69 5.997 15.309 15.309 0 01-5.808 3.744 21.136 21.136 0 01-7.368 1.24 21.39 21.39 0 01-7.404-1.24 15.663 15.663 0 01-5.8-3.692 17.124 17.124 0 01-3.761-6.04 23.635 23.635 0 01-1.351-8.321v-36.37h15.28v35.092c-.112 1.594.14 3.194.734 4.667.246.388.589.697.992.894.403.197.85.274 1.292.223a2.17 2.17 0 001.251-.214c.388-.195.715-.501.942-.884.557-1.49.789-3.09.68-4.686V61.335z"
                    clipRule="evenodd"
                ></path>
            </svg>
        </div>
    )
}